<template>
    <div>
        <card-header title="Courses" icon="fa-cubes"/>

        <card-toolbar>
            <button @click="$openCard('new-course', {}, card)"><i class="far fa-plus"></i>New Course</button>
        </card-toolbar>

        <card-body>
            <card-list>
<!--                <search-list-item/>-->
<!--                <separator-list-item/>-->
                <subheader-list-item title="Active Courses" icon="fa-chalkboard-teacher"/>
                <course-tile
                    :card="card"
                    :course="c"
                    v-for="c in activeCourses"
                    @click="$openCard('course', {courseId: c.id}, card)"
                    :active="child && child.definition.component === 'course' && child.props.courseId == c.id"
                />
                <subheader-list-item title="Disabled Courses" icon="fa-chalkboard-teacher"/>
                <course-tile
                    :card="card"
                    :course="c"
                    v-for="c in inactiveCourses"
                    @click="$openCard('course', {courseId: c.id}, card)"
                    :active="child && child.definition.component === 'course' && child.props.courseId == c.id"
                />
            </card-list>
        </card-body>
    </div>
</template>

<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardBody from "@/TIER/components/CardBody";
    import CardList from "@/TIER/components/CardList";
    import SearchListItem from "@/TIER/components/SearchListItem";
    import SeparatorListItem from "@/TIER/components/SeparatorListItem";
    import CardToolbar from "@/TIER/components/CardToolbar";

    import CourseTile from "@/components/tiles/CourseTile";

    import {client as http} from "@/http_client";
    import SubheaderListItem from "../../TIER/components/SubheaderListItem.vue";
    import moment from "moment/moment";

    export default {
        components: {SubheaderListItem, CourseTile, CardToolbar, SeparatorListItem, CardHeader, CardBody, CardList, SearchListItem},
        props: ['card', 'child'],
        data() {
            return {
                courses: []
            }
        },
        computed: {
            activeCourses: function() {
                return this.courses.filter(c => c.active).sort((a, b) => a.title.localeCompare(b.title));
            },
            inactiveCourses: function() {
                return this.courses.filter(c => !c.active).sort((a, b) => a.title.localeCompare(b.title));
            }
        },
        methods: {
            loadCourses: function (force) {
                this.$emit('loading', true);

                http.get('courses/new/', {force}).then(response => {
                    this.courses = response.data;
                    this.$emit('loading', false);
                }, err => {
                    console.log(err);
                });
            },
            reload: function() {
                this.loadCourses(true);
            }
        },
        mounted: function() {
            this.loadCourses();
        }
    }
</script>
